import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import CloseIcon from '@material-ui/icons/Close';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import StopIcon from '@material-ui/icons/Stop';
import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
import SkipNextIcon from '@material-ui/icons/SkipNext';

import { formatDateTime } from '../../../api/date';
import { formatSpeed } from '../../api/Settings';
import { IconButton, Paper } from '@material-ui/core';
import { SortableTable } from '../../../components/SortableTable';

class TrackPanel_ extends React.Component{

    constructor(props){
        super(props);

        this.handleCloseClick = this.handleCloseClick.bind(this)
        this.handleTableRowClick = this.handleTableRowClick.bind(this)
        this.handleNext = this.handleNext.bind(this) 
        this.handlePrev = this.handlePrev.bind(this)
        this.handlePlayStart = this.handlePlayStart.bind(this)
        this.handlePlayStop = this.handlePlayStop.bind(this)
    }

    handleCloseClick(){
        this.props.onAction({type:'TRACK_PANEL_CLOSE'})
    }

    handleTableRowClick(row, index){
        this.props.onAction({type:'TRACK_PANEL_ITEM_SELECT', index: row.index})
        //alert('click '+ index)
    }

    handleNext(){
        this.props.onAction({type:'TRACK_PANEL_NEXT'})
    }

    handlePrev(){
        this.props.onAction({type:'TRACK_PANEL_PREV'})
    }
    
    handlePlayStart(){
        this.props.onAction({type:'TRACK_PANEL_PLAY_START'})
    }
    handlePlayStop(){
        this.props.onAction({type:'TRACK_PANEL_PLAY_STOP'})
    }

    render(){
        const {t} = this.props

        console.log('renderTrackPanel')
        console.log(this.props.track.points)  

        let columns = [
            {
                label: t('DateTime'),
                name: 'dt',
                eval: (val)=>{return formatDateTime(val, 'full_date')},
                allowSort: true,
            },
            {
                label: t('Speed'),
                name: 'speed',
                eval: (val)=>(formatSpeed(val)),
                allowSort: true,
            },
            {
                label: t('Accuracy'),
                name: 'accuracy',
                eval: (val)=>(val ? val.toFixed(2) : 0),
                allowSort: true,
                sortEval2: (val)=>(val ? val.toFixed(2) : 0),
            },
            {
                label: t('Distance'),
                name: 'distance',
                eval: (val)=>(val ? val.toFixed(2) : 0),
                allowSort: true,
                sortEval2: (val)=>(val ? val.toFixed(3) : 0),
            },
            {
                label: t('Coordinates'),
                name: 'event',
                eval: (val, row)=>(
                    (row.latitude ? row.latitude.toFixed(7) : '')  +  ' ' +
                    (row.longitude ? row.longitude.toFixed(7) : '' )
                ),
                allowSort: true,
                sortEval: (val, row)=>(
                    (row.latitude ? row.latitude.toFixed(7) : '')  +  ' ' +
                    (row.longitude ? row.longitude.toFixed(7) : '' )
                ),
            },  
        ]

        console.log('this.props.track')
        console.log(this.props.track)


        return (
            <Paper>

            <IconButton onClick={this.handleCloseClick}>
                <CloseIcon />
            </IconButton>
            <IconButton onClick={this.handlePlayStart}>
                <PlayArrowIcon/>
            </IconButton>
            <IconButton onClick={this.handlePlayStop}>
                <StopIcon />
            </IconButton>
            <IconButton onClick={this.handlePrev}>
                <SkipPreviousIcon />
            </IconButton>
            <IconButton onClick={this.handleNext}>
                <SkipNextIcon />
            </IconButton>
            

            <div style={{overflow:'scroll', maxHeight: 300}}>

            
            <SortableTable
                    t={t}
                    rows={this.props.track.points}
                    columns={columns}
                    version={this.props.track.version}
                    primaryKey="index"
                    onRowClick={this.handleTableRowClick}
                />
{/** 

            <table>

                <tr>
                    <td>{t('Date/Time')}</td>
                    <td>{t('Speed')}</td>
                    <td>{t('Accuracy')}</td>
                    <td>{t('Distance')}</td>
                    <td>{t('Coordinates')}</td>
                </tr>

                {this.props.track.points.map(point =>  (

                    <tr>
                        <td>{formatDateTime(point.dt)}</td>
                        <td>{formatSpeed(point.speed)}</td>
                        <td>{point.accuracy ? point.accuracy.toFixed(2) : 0}</td>
                        <td>{point.distance ? point.distance.toFixed(3) : 0}</td>
                        <td>{point.latitude ? point.latitude.toFixed(7) : ''} <br/>
                            {point.longitude ? point.longitude.toFixed(7) : '' } 
                        </td>
                    </tr>

                ) )}

            </table>

*/}

            </div>
            </Paper>
        )
    }


}



export const TrackPanel = withTranslation()(TrackPanel_);